import {FC, useState} from 'react';
import {useRecoilValue} from 'recoil';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import {partyRelOfContactPersonSelectorFamily} from '../../../../store/contact-person/selectors';

import {IContactPerson} from '../../../../shared/types/person.types';
import {Table, TableBody, TableHead} from '@mui/material';
import {getFullName} from '../../../../shared/helpers/getFullName';

interface IShowContactPersonRow {
  row: IContactPerson;
}

const ShowContactPersonRow: FC<IShowContactPersonRow> = ({row}) => {
  const partyRel = useRecoilValue(partyRelOfContactPersonSelectorFamily(row.id));
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow sx={{cursor: 'pointer'}} onClick={() => setOpen(!open)}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="left">{getFullName(row)}</TableCell>
        <TableCell align="left">{row.phoneNumber}</TableCell>
        <TableCell align="left">{row.email}</TableCell>
        <TableCell align="left">{row.birthDate}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{fontWeight: 'bold'}} align="center">
                    Должность
                  </TableCell>
                  <TableCell sx={{fontWeight: 'bold'}} align="center">
                    Зона ответственности
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{partyRel?.relationTitle}</TableCell>
                  <TableCell>{partyRel?.description}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default ShowContactPersonRow;
